import { render } from "./PageStrategies.vue?vue&type=template&id=5a84ae8a"
import script from "./PageStrategies.vue?vue&type=script&lang=js"
export * from "./PageStrategies.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__